import { extendTheme } from "@chakra-ui/react";
import { inputStyle } from "./components/input";
import { buttonStyle } from "./components/button";
import { checkboxStyles } from "./components/checkbox";
import { dividerStyle } from "./components/divider";
import { linkStyle } from "./components/link";
import { textareaStyle } from "./components/textarea";
import { switchStyle } from "./components/switch";

export const theme = extendTheme({
  semanticTokens: {
    colors: {
      primary: "#CE0058",
      "primary-light": "#e83a78",
      secondary: "#AEAEB2",
      bg: "#232324",
    },
  },
  fonts: {
    heading: "Helvetica Neue,-apple-system,BlinkMacSystemFont,sans-serif",
    body: "Helvetica Neue,-apple-system,BlinkMacSystemFont,sans-serif",
  },
  styles: {
    global: {
      "html, body": {
        bg: "bg",
      },
    },
  },
  components: {
    Input: inputStyle,
    Textarea: textareaStyle,
    Button: buttonStyle,
    Checkbox: checkboxStyles,
    Divider: dividerStyle,
    Link: linkStyle,
    Switch: switchStyle,
  },
});
